import * as React from "react";

const SvgLightSnowThunder = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunder_svg__a">
        <path
          d="m1208.592 229.026-5.267-9.123c-.825-1.428-.154-2.499 1.492-2.378l4.302.315c1.646.122 2.348-.965 1.56-2.415l-4.785-8.806c-.788-1.45-.39-1.778.884-.73l17.302 14.229c1.274 1.048.968 1.836-.679 1.752l-6.612-.338c-1.647-.084-2.32 1.016-1.496 2.445l2.91 5.04c.825 1.428.15 2.598-1.5 2.601h-3.611c-1.65 0-3.676-1.166-4.5-2.594"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunder_svg__b">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunder_svg__c">
        <path d="M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunder_svg__d">
        <path d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunder_svg__e">
        <path d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunder_svg__f">
        <path d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
    </defs>
    <g
      transform="matrix(1.33333 0 0 -1.33333 -1554.56 355.264)"
      clipPath="url(#LightSnowThunder_svg__a)"
      style={{
        fill: "#fec225",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#fec225",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1208.592 229.026-5.267-9.123c-.825-1.428-.154-2.499 1.492-2.378l4.302.315c1.646.122 2.348-.965 1.56-2.415l-4.785-8.806c-.788-1.45-.39-1.778.884-.73l17.302 14.229c1.274 1.048.968 1.836-.679 1.752l-6.612-.338c-1.647-.084-2.32 1.016-1.496 2.445l2.91 5.04c.825 1.428.15 2.598-1.5 2.601l-3.611.002c-1.65.002-3.676-1.166-4.5-2.594"
          style={{
            fill: "#fec225",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunder_svg__b)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.89 0 10.664 4.774 10.664 10.664S5.89 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.199S-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(473.696 377.985)"
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunder_svg__c)"
      style={{
        fill: "#d3e9f8",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
    >
      <g
        style={{
          fill: "#d3e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
          style={{
            fill: "#d3e9f8",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunder_svg__d)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -575.403 556.494)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunder_svg__e)"
      transform="matrix(1.33333 0 0 -1.33333 -588.62 556.494)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunder_svg__f)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -582.653 561.178)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 384 -166.15)"
      d="M-288 124.612h72v72h-72z"
    />
  </svg>
);

export default SvgLightSnowThunder;
